import React from 'react';

const Filter = ({ percentage }) => {
    return (
        <div className="custom-filter" style={{ width: `${percentage}%` }}></div>
    );
}

export default Filter;